interface Props {
  [key: string]: any
}

export default function InvitePersonIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 16 16" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M6 8.5C7.38071 8.5 8.5 7.38071 8.5 6C8.5 4.61929 7.38071 3.5 6 3.5C4.61929 3.5 3.5 4.61929 3.5 6C3.5 7.38071 4.61929 8.5 6 8.5Z"
        stroke="none"
        strokeWidth="1.4"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M2 13C2 10.79 3.79 9 6 9H7"
        stroke="none"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M11.5 7V11M9.5 9H13.5"
        stroke="none"
        strokeLinecap="round"
        strokeWidth="1.6"
      />
    </svg>
  )
}
